<template>
  <el-form :model="form" ref="form" label-width="120px">
    <!-- 新字段 -->
    <el-form-item label="公司名称" prop="companyName">
      <el-input v-model="form.companyName" :disabled="loading" placeholder="公司名称"></el-input>
    </el-form-item>
    <el-form-item label="游戏标题" prop="title" required :rules="requiredTrimRules('请输入游戏标题')">
      <el-input v-model="form.title" :disabled="loading" placeholder="游戏标题"></el-input>
    </el-form-item>
    <el-form-item label="平台" prop="webPlatform" required :rules="requiredTrimRules('请选择平台')">
      <el-select v-model="form.webPlatform" :disabled="loading" placeholder="选择平台" style="width: 100%">
        <el-option label="Puzzlegame" value="Puzzlegame"></el-option>
        <el-option label="Rabigame" value="Rabigame"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="Game ID" prop="gameId" required :rules="requiredTrimRules('请输入 Game ID')">
      <el-input v-model="form.gameId" :disabled="loading" placeholder="游戏唯一标识"></el-input>
    </el-form-item>
    <el-form-item label="Game MD5" prop="gameMd5" required :rules="requiredTrimRules('请输入 Game MD5')">
      <el-input v-model="form.gameMd5" :disabled="loading" placeholder="游戏MD5"></el-input>
    </el-form-item>
    <el-form-item label="游戏URL" prop="gameUrl" required :rules="requiredTrimRules('请输入游戏 URL')">
      <el-input v-model="form.gameUrl" :disabled="loading" placeholder="游戏URL"></el-input>
    </el-form-item>
    <el-form-item label="开发者名称" prop="developerName">
      <el-input v-model="form.developerName" :disabled="loading" placeholder="开发者名称"></el-input>
    </el-form-item>
    <el-form-item label="评分" prop="rating">
      <el-input-number v-model="form.rating" :disabled="loading" :min="0" :max="10" :step="0.1" :precision="1" style="width: 180px" />
    </el-form-item>
    <el-form-item label="投票数" prop="voteCount">
      <el-input-number v-model="form.voteCount" :disabled="loading" :min="0" style="width: 180px" />
    </el-form-item>
    <el-form-item label="点赞数" prop="upvoteCount">
      <el-input-number v-model="form.upvoteCount" :disabled="loading" :min="0" style="width: 180px" />
    </el-form-item>
    <el-form-item label="点踩数" prop="downvoteCount">
      <el-input-number v-model="form.downvoteCount" :disabled="loading" :min="0" style="width: 180px" />
    </el-form-item>
    <el-form-item label="关联文章ID" prop="articleId">
      <el-input v-model="form.articleId" :disabled="loading" placeholder="可留空，由文章编辑自动关联"></el-input>
    </el-form-item>
    <el-form-item label="分类" prop="category">
      <el-select v-model="form.category" :disabled="loading" filterable clearable placeholder="选择分类">
        <el-option v-for="c in categoryList" :key="c.id" :label="c.name" :value="c.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="游戏描述" prop="desc" :rules="[{required: false, message: '请输入游戏描述'}]">
      <el-input v-model="form.desc" :disabled="loading" type="textarea" :autosize="{ minRows: 3, maxRows: 8}" placeholder="游戏描述"></el-input>
    </el-form-item>
    <!-- 兼容旧字段 -->
    <el-form-item label="URL (旧)" prop="url" v-if="!form.gameUrl">
      <el-input v-model="form.url" :disabled="loading" placeholder="兼容旧字段"></el-input>
    </el-form-item>
    <el-form-item label="name (旧)" prop="name" v-if="!form.title">
      <el-input v-model="form.name" :disabled="loading" placeholder="兼容旧字段"></el-input>
    </el-form-item>
    <el-form-item label="标签" prop="tags">
      <el-select v-model="form.tags" style="width: 100%" filterable clearable :disabled="loading" multiple allow-create>
        <el-option v-for="i in tagList" :key="i" :value="i"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="移动端模式" prop="mobileMode">
      <el-select v-model="form.mobileMode" :disabled="loading" clearable placeholder="选择移动端模式">
        <el-option label="Portrait" value="Portrait"></el-option>
        <el-option label="Landscape" value="Landscape"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="移动端支持" prop="mobile">
      <el-select v-model="form.mobile" style="width: 100%" :disabled="loading" multiple placeholder="选择移动端支持">
        <el-option label="ForIOS" value="ForIOS"></el-option>
        <el-option label="ForAndroid" value="ForAndroid"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="发布时间" prop="publishedAt">
      <el-date-picker
        v-model="form.publishedAt"
        type="datetime"
        :disabled="loading"
        placeholder="选择发布时间"
        format="YYYY-MM-DD HH:mm:ss"
        value-format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
      />
    </el-form-item>
    <el-form-item label="使用说明" prop="instruction">
      <el-input v-model="form.instruction" :disabled="loading" type="textarea" :autosize="{ minRows: 2, maxRows: 5}" placeholder="游戏使用说明"></el-input>
    </el-form-item>
    <el-form-item label="支持语言" prop="languages">
      <el-select v-model="form.languages" style="width: 100%" :disabled="loading" multiple filterable allow-create placeholder="选择支持的语言">
        <el-option label="中文" value="zh"></el-option>
        <el-option label="English" value="en"></el-option>
        <el-option label="日本語" value="ja"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="图标" prop="iconUrl">
      <el-upload :http-request="handleIconUpload" :show-file-list="false" accept="image/*">
        <template v-if="form.iconUrl || form.icon">
          <div class="image-preview-container">
            <img :src="processImageUrl(form.iconUrl || form.icon, $CDN_URL)" class="image-preview" />
            <div class="upload-overlay">
              <span class="upload-text">重新上传</span>
            </div>
          </div>
        </template>
        <el-button v-else size="small" :loading="loading">上传图标</el-button>
      </el-upload>
    </el-form-item>
    <el-form-item label="封面图" prop="coverUrl">
      <el-upload :http-request="handleCoverUpload" :show-file-list="false" accept="image/*">
        <template v-if="form.coverUrl || form.cover">
          <div class="image-preview-container">
            <img :src="processImageUrl(form.coverUrl || form.cover, $CDN_URL)" class="image-preview cover-preview" />
            <div class="upload-overlay">
              <span class="upload-text">重新上传</span>
            </div>
          </div>
        </template>
        <el-button v-else size="small" :loading="loading">上传封面</el-button>
      </el-upload>
    </el-form-item>
    <!-- 兼容旧字段 -->
    <el-form-item label="精选" v-if="form.is_hot !== undefined || form.is_recommended !== undefined">
      <el-checkbox v-model="form.is_hot" :disabled="loading">Hot</el-checkbox>
      <el-checkbox v-model="form.is_recommended" :disabled="loading">Recommended</el-checkbox>
    </el-form-item>
    <el-form-item label="label (旧)" prop="label" v-if="form.label !== undefined">
      <el-select v-model="form.label" :disabled="loading" filterable clearable>
        <el-option v-for="c in labelList" :key="c" :label="c" :value="c"></el-option>
      </el-select>
    </el-form-item>
  </el-form>
  
  <div style="margin-top: 20px;">
    <el-button type="default" size="small" @click="showJsonSection = !showJsonSection">
      {{ showJsonSection ? '隐藏' : '显示' }} JSON 导入
    </el-button>
  </div>
  
  <div v-if="showJsonSection" class="json-section">
    <div class="json-header">
      <h3>JSON 导入</h3>
      <el-button type="primary" size="small" @click="importJsonData">导入 JSON</el-button>
    </div>
    <el-input
      v-model="jsonString"
      type="textarea"
      :rows="12"
      placeholder="请输入JSON数据..."
      monospace
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {GameApi, Game, CategoryOption} from '../../api/gameApi';
import {processImageUrl} from '../../utils/utils';

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $message: any;
    $CDN_URL: string;
  }
}

export default defineComponent({
  name: 'GameForm',
  props: {
    form: {
      type: Object as () => Game,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    categoryList: {
      type: Array as () => CategoryOption[],
      required: true
    },
    labelList: {
      type: Array as () => string[],
      required: true
    },
    tagList: {
      type: Array as () => string[],
      required: true
    }
  },
  data() {
    return {
      jsonString: '',
      showJsonSection: false
    }
  },
  emits: ['update:form', 'validate'],
  methods: {
    processImageUrl,
    requiredTrimRules(message: string) {
      return [
        {
          validator: (_rule: unknown, value: unknown, callback: (e?: Error) => void) => {
            if (value === undefined || value === null || String(value).trim() === '') {
              callback(new Error(message));
            } else {
              callback();
            }
          },
          trigger: 'blur',
        },
      ];
    },
    validate(callback: (valid: boolean) => void): void {
      (this.$refs.form as any).validate(callback);
    },
    resetFields(): void {
      (this.$refs.form as any).resetFields();
    },
    handleIconUpload({ file }: { file: File }): void {
      GameApi.uploadResource(file, 'game')
        .then(filename => {
          this.$emit('update:form', {
            ...this.form,
            iconUrl: filename,
            icon: filename // 兼容旧字段
          });
        })
        .catch(error => {
          this.$message.error(`上传失败：${error instanceof Error ? error.message : '未知错误'}`);
        });
    },
    handleCoverUpload({ file }: { file: File }): void {
      GameApi.uploadResource(file, 'game')
        .then(filename => {
          this.$emit('update:form', {
            ...this.form,
            coverUrl: filename,
            cover: filename // 兼容旧字段
          });
        })
        .catch(error => {
          this.$message.error(`上传失败：${error instanceof Error ? error.message : '未知错误'}`);
        });
    },
    importJsonData(): void {
      try {
        if (!this.jsonString || this.jsonString.trim() === '') {
          this.$message.error('请输入有效的JSON数据');
          return;
        }
        
        const jsonData = JSON.parse(this.jsonString);
        
        if (!jsonData || typeof jsonData !== 'object') {
          this.$message.error('请输入有效的JSON对象');
          return;
        }
        
        const formData = { ...this.form };
        
        // 映射新JSON格式到表单字段（参考 hrefs-test.json）
        if (jsonData.companyName !== undefined) formData.companyName = jsonData.companyName;
        if (jsonData.coverUrl !== undefined) formData.coverUrl = jsonData.coverUrl;
        if (jsonData.iconUrl !== undefined) formData.iconUrl = jsonData.iconUrl;
        if (jsonData.title !== undefined) formData.title = jsonData.title;
        if (jsonData.webPlatform === 'Puzzlegame' || jsonData.webPlatform === 'Rabigame') {
          formData.webPlatform = jsonData.webPlatform;
        }
        if (jsonData.category !== undefined) {
          formData.category = typeof jsonData.category === 'string' ? jsonData.category : '';
        }
        if (jsonData.desc !== undefined) formData.desc = jsonData.desc;
        if (jsonData.gameId !== undefined) formData.gameId = jsonData.gameId;
        if (jsonData.gameMd5 !== undefined) formData.gameMd5 = jsonData.gameMd5;
        if (jsonData.gameUrl !== undefined) formData.gameUrl = jsonData.gameUrl;
        if (jsonData.tags !== undefined) {
          formData.tags = Array.isArray(jsonData.tags) ? jsonData.tags : [];
        }
        if (jsonData.categories !== undefined && !formData.category) {
          if (Array.isArray(jsonData.categories) && jsonData.categories.length > 0) {
            formData.category = String(jsonData.categories[0]);
          }
        }
        if (jsonData.publishedAt !== undefined) formData.publishedAt = jsonData.publishedAt;
        if (jsonData.mobileMode !== undefined) formData.mobileMode = jsonData.mobileMode;
        if (jsonData.mobile !== undefined) {
          formData.mobile = Array.isArray(jsonData.mobile) ? jsonData.mobile : [];
        }
        if (jsonData.instruction !== undefined) formData.instruction = jsonData.instruction;
        if (jsonData.languages !== undefined) {
          formData.languages = Array.isArray(jsonData.languages) ? jsonData.languages : [];
        }
        
        // 兼容旧字段
        if (jsonData.url !== undefined) {
          formData.url = jsonData.url;
          if (!formData.gameUrl) formData.gameUrl = jsonData.url;
        }
        if (jsonData.name !== undefined) {
          formData.name = jsonData.name;
          if (!formData.title) formData.title = jsonData.name;
        }
        if (jsonData.description !== undefined) {
          if (!formData.desc) formData.desc = jsonData.description;
        }
        if (jsonData.icon !== undefined) {
          formData.icon = jsonData.icon;
          if (!formData.iconUrl) formData.iconUrl = jsonData.icon;
        }
        if (jsonData.cover !== undefined) {
          formData.cover = jsonData.cover;
          if (!formData.coverUrl) formData.coverUrl = jsonData.cover;
        }
        if (jsonData.is_hot !== undefined) formData.is_hot = jsonData.is_hot;
        if (jsonData.is_recommended !== undefined) formData.is_recommended = jsonData.is_recommended;
        if (jsonData.label !== undefined) formData.label = jsonData.label;
        if (jsonData.active !== undefined) formData.active = jsonData.active;
        
        // 更新表单
        this.$emit('update:form', formData);
        this.$message.success('JSON数据导入成功');
      } catch (error) {
        this.$message.error(`导入失败：${error instanceof Error ? error.message : '未知错误'}`);
      }
    }
  }
});
</script>

<style scoped>
.image-preview-container {
  position: relative;
  width: 200px;
  height: 200px;
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
}

.image-preview-container:hover {
  border-color: #409eff;
  box-shadow: 0 0 10px rgba(64, 158, 255, 0.2);
}

.image-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.cover-preview {
  object-fit: contain;
  background-color: #fafafa;
}

.upload-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-preview-container:hover .upload-overlay {
  opacity: 1;
}

.upload-text {
  color: #fff;
  font-size: 14px;
  font-weight: bold;
}

.json-section {
  margin-top: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.json-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.json-header h3 {
  margin: 0;
  font-size: 16px;
  color: #303133;
}
</style>